import { Alert, AlertType } from '@design/components/alert/Alert';
import { Icon } from '@design/components/icon/Icon';
import { useTranslation } from 'react-i18next';

import styles from './InlineAlert.module.scss';

export const InlineAlert = () => {
  const { t } = useTranslation(['chat']);

  return (
    <Alert
      className={styles.alert}
      type={AlertType.Info}
      variant="inline"
      message={t('chat:trustedSources.modal.exceededLimit')}
      customIcon={
        <Icon
          fillColor="var(--icon-primary)"
          iconName="InformationCircle"
          size={20}
        />
      }
    />
  );
};
